import React from "react";
import { Form, Select, TimePicker, Button, DatePicker } from "antd";
import { MinusOutlined, PlusOutlined, MenuOutlined } from "@ant-design/icons";
import { FieldArray } from "formik";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const { Option } = Select;

const DragAndDrop = ({
  values,
  errors,
  touched,
  setFieldValue,
  suppliersData,
  templateDetails,
  mode,
  setIsDirty,
  dateFormat,
}) => {
  const format = "HH:mm";

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = Array.from(values.suppliersIds);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    setFieldValue("suppliersIds", reorderedItems);
    setIsDirty(true);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <FieldArray
        name="suppliersIds"
        render={({ push, remove }) => {
          const templates = values.suppliersIds;
          const error = errors.suppliersIds ?? [""];
          const touch = touched.suppliersIds ?? [""];
          const isOk = Boolean(touch && error);

          return (
            <Droppable droppableId="suppliers">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {templates.map((_, index) => (
                    <Draggable
                      key={index}
                      draggableId={`suppliers-${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div key={index}>
                            <div className="route_supplier_front">
                              <div style={{ marginTop: "2.5rem", width: "3%" }}>
                                <MenuOutlined style={{ cursor: "grab" }} />
                              </div>
                              <div className="route_select_plant_content">
                                <Form.Item style={{ margin: "0" }}>
                                  <label
                                    htmlFor={`supplier${index}`}
                                    className="form-label required "
                                  >
                                    Select Supplier
                                  </label>
                                  <Select
                                    id={`supplier${index}`}
                                    style={{
                                      height: "2.7rem",
                                    }}
                                    placeholder="Select a supplier"
                                    onChange={(value) => {
                                      setFieldValue(
                                        `suppliersIds.${index}.id`,
                                        value
                                      );
                                      setIsDirty(true);
                                    }}
                                    value={values.suppliersIds[index].id}
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    status={
                                      (isOk &&
                                        error[index]?.id &&
                                        touch[index]?.id &&
                                        "error") ||
                                      ""
                                    }
                                    disabled={mode === "view"}
                                  >
                                    {suppliersData?.map((option) => (
                                      <Option key={option.id} value={option.id}>
                                        {option.code} - {option.address}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                {isOk &&
                                  error[index]?.id &&
                                  touch[index]?.id && (
                                    <small
                                      id={`id${index}-help`}
                                      className="error-message"
                                    >
                                      {error[index]?.id}
                                    </small>
                                  )}
                              </div>

                              <div className="route_plant_front_content">
                                <Form.Item style={{ margin: "0" }}>
                                  <label
                                    htmlFor={`arriveDate${index}`}
                                    className="form-label required"
                                  >
                                    Arrival Date
                                  </label>
                                  <DatePicker
                                    format={dateFormat}
                                    style={{ height: "2.7rem", width: "100%" }}
                                    id={`arriveDate${index}`}
                                    onChange={(value) => {
                                      setFieldValue(
                                        `suppliersIds.${index}.arriveDate`,
                                        value
                                      );
                                      setIsDirty(true);
                                    }}
                                    value={
                                      values.suppliersIds[index].arriveDate
                                    }
                                    placeholder="YYYY-MM-DD"
                                    status={
                                      (isOk &&
                                        error[index]?.arriveDate &&
                                        touch[index]?.arriveDate &&
                                        "error") ||
                                      ""
                                    }
                                    disabled={mode === "view"}
                                  />
                                </Form.Item>
                                {isOk &&
                                  error[index]?.arriveDate &&
                                  touch[index]?.arriveDate && (
                                    <small
                                      id={`arriveDate${index}-help`}
                                      className="error-message"
                                    >
                                      {error[index]?.arriveDate}
                                    </small>
                                  )}
                              </div>
                              <div className="route_plant_front_content">
                                <Form.Item style={{ margin: "0" }}>
                                  <label
                                    htmlFor={`arriveTime${index}`}
                                    className="form-label required"
                                  >
                                    Arrival Time
                                  </label>
                                  <TimePicker
                                    style={{ height: "2.8rem" }}
                                    id={`arriveTime${index}`}
                                    format={format}
                                    onChange={(value) => {
                                      setFieldValue(
                                        `suppliersIds.${index}.arriveTime`,
                                        value
                                      );
                                      setIsDirty(true);
                                    }}
                                    value={
                                      values.suppliersIds[index].arriveTime
                                    }
                                    placeholder="HH:MM"
                                    status={
                                      (isOk &&
                                        error[index]?.arriveTime &&
                                        touch[index]?.arriveTime &&
                                        "error") ||
                                      ""
                                    }
                                    disabled={mode === "view"}
                                  />
                                </Form.Item>
                                {isOk &&
                                  error[index]?.arriveTime &&
                                  touch[index]?.arriveTime && (
                                    <small
                                      id={`arriveTime${index}-help`}
                                      className="error-message"
                                    >
                                      {error[index]?.arriveTime}
                                    </small>
                                  )}
                              </div>
                              <div className="route_plant_front_content">
                                <Form.Item style={{ margin: "0" }}>
                                  <label
                                    htmlFor={`departDate${index}`}
                                    className="form-label required"
                                  >
                                    Depart Date
                                  </label>
                                  <DatePicker
                                    format={dateFormat}
                                    style={{ height: "2.7rem", width: "100%" }}
                                    id={`departDate${index}`}
                                    onChange={(value) => {
                                      setFieldValue(
                                        `suppliersIds.${index}.departDate`,
                                        value
                                      );
                                      setIsDirty(true);
                                    }}
                                    value={
                                      values.suppliersIds[index].departDate
                                    }
                                    placeholder="YYYY-MM-DD"
                                    status={
                                      (isOk &&
                                        error[index]?.departDate &&
                                        touch[index]?.departDate &&
                                        "error") ||
                                      ""
                                    }
                                    disabled={mode === "view"}
                                  />
                                </Form.Item>
                                {isOk &&
                                  error[index]?.departDate &&
                                  touch[index]?.departDate && (
                                    <small
                                      id={`departDate${index}-help`}
                                      className="error-message"
                                    >
                                      {error[index]?.departDate}
                                    </small>
                                  )}
                              </div>
                              <div className="route_plant_front_content">
                                <Form.Item style={{ margin: "0" }}>
                                  <label
                                    htmlFor={`departTime${index}`}
                                    className="form-label required"
                                  >
                                    Depart Time
                                  </label>
                                  <TimePicker
                                    style={{ height: "2.8rem" }}
                                    id={`departTime${index}`}
                                    format={format}
                                    onChange={(value) => {
                                      setFieldValue(
                                        `suppliersIds.${index}.departTime`,
                                        value
                                      );
                                      setIsDirty(true);
                                    }}
                                    value={
                                      values.suppliersIds[index].departTime
                                    }
                                    placeholder="HH:MM"
                                    status={
                                      (isOk &&
                                        error[index]?.departTime &&
                                        touch[index]?.departTime &&
                                        "error") ||
                                      ""
                                    }
                                    disabled={mode === "view"}
                                  />
                                </Form.Item>
                                {isOk &&
                                  error[index]?.departTime &&
                                  touch[index]?.departTime && (
                                    <small
                                      id={`departTime${index}-help`}
                                      className="error-message"
                                    >
                                      {error[index]?.departTime}
                                    </small>
                                  )}
                              </div>
                              <div style={{ marginTop: "2.5rem" }}>
                                {index >= 1 ? (
                                  <Button
                                    icon={<MinusOutlined />}
                                    onClick={() => {
                                      remove(index);
                                      setIsDirty(true);
                                    }}
                                    className="minus_button"
                                    disabled={mode === "view"}
                                  />
                                ) : (
                                  <Button
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                      push({ ...templateDetails });
                                      setIsDirty(true);
                                    }}
                                    className="plus_button"
                                    disabled={mode === "view"}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          );
        }}
      />
    </DragDropContext>
  );
};

export default DragAndDrop;
